import { axios } from '@/utils/request'

export const apiLogin = {
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: '/account/sms',
  SendSmsErr: '/account/sms_err',
  // get my info
  UserInfo: '/user/info'
}

export function getSmsCaptcha(parameter) {
  return axios({
    url: apiLogin.SendSms,
    method: 'post',
    data: parameter
  })
}